var path = '/src/app.html';
var html = "<div ui-view=\"header\"></div>\n<version-label></version-label>\n<div ui-view=\"main\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;